import React, { useEffect } from 'react'
import { Router as BrowserRouter } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import Main from './components/main'
import GtmInitialiser from './gtm-initialiser'
import AsyncModal from './layouts/routed-modal'
import ErrorDialog from './components/error-dialog'
import { initialiseGa } from './lib/analytics/ga'
import configFreshChat from './lib/freshchat'
import { setTheme } from './actions'
import { THEME_OPTIONS } from './constants'

const App = ({ history }) => {
  const dispatch = useDispatch()

  // Apply LIGHTBOX_DARK when the app starts so every route uses the dark theme.
  useEffect(() => {
    dispatch(setTheme(THEME_OPTIONS.dark))
  }, [dispatch])

  useEffect(() => {
    const cleanupFreshchat = configFreshChat(history)
    return () => {
      cleanupFreshchat()
    }
  })

  initialiseGa(history)

  return (
    <BrowserRouter history={history}>
      <>
        <Main />
        <GtmInitialiser />
        <AsyncModal />
        <ErrorDialog />
      </>
    </BrowserRouter>
  )
}

export default App
